/* eslint-disable import/prefer-default-export */
export interface Policy {}

// Reducer
export const defaultState = {
  policyList: null as any,
  policiesList: [] as Policy[],
  selectedPolicy: null as string | null,
  isPending: false,
  errors: null as any
}

export type PoliciesState = typeof defaultState
